import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  SettlementItemsByBrandQueryParams,
  SettlementItemsQueryParams,
  SettlementItemsTotalByStatusQueryParams,
} from '../types/apis';
import {
  SettlementItemsFindAllResponseDto,
  SettlementItemsFindOneResponseDto,
  SettlementItemsFindTotalByStatusResponseDto,
  SettlementItemsFindTotalResponseDto,
} from '../../../types/api/settlement-items';
import { settlementApi } from '../../../lib/api/settlement';
import { BrandSettlementsFindAllResponseDto } from '../../../types/api/brands';

export const settlementQuery = createQueryKeys('settlement', {
  list: (params: SettlementItemsQueryParams) => ({
    queryFn: (): Promise<SettlementItemsFindAllResponseDto> => {
      return settlementApi.getSettlementItems(params);
    },
    queryKey: [params],
    contextQueries: {
      total: {
        queryKey: null,
        queryFn: (): Promise<SettlementItemsFindTotalResponseDto> => {
          return settlementApi.getSettlementItemsTotal(params);
        },
      },
    },
  }),
  detail: (settlementId) => ({
    queryKey: [settlementId],
    queryFn: (): Promise<SettlementItemsFindOneResponseDto> => settlementApi.getSettlementItem(settlementId),
  }),

  totalByStatus: (params: SettlementItemsTotalByStatusQueryParams) => ({
    queryKey: [params],
    queryFn: (): Promise<SettlementItemsFindTotalByStatusResponseDto> => {
      return settlementApi.getSettlementItemsTotalByStatus(params);
    },
  }),

  listByBrand: (params: SettlementItemsByBrandQueryParams) => ({
    queryKey: [params],
    queryFn: (): Promise<BrandSettlementsFindAllResponseDto> => {
      return settlementApi.getSettlementItemsByBrand(params);
    },
  }),
});
